import axios from "axios";
import * as jwtUtil from "@/utils/jwtUtil";
import store from "@/stores";
import router from "@/router/router";
import { baseURL } from "@/data/url";

const instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json;charset=utf-8;",
    "Access-Control-Allow-Origin": "*",
  },
});

instance.interceptors.request.use(
  async (config) => {
    var url = config.url;

    // JWT 인증이 필요한 요청일 경우 header 작업
    if (isAuthRequest(url)) {
      // Local Storage에서 JWT를 가져온다.
      var jwt = localStorage.getItem(jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN);

      // Access Token 검증
      var payload = jwtUtil.parsePayload(jwt);
      if (payload.exp < Date.now() / 1000 - 300) {
        console.log("Access token was expired.");

        // refreshAccessToken 을 기다린다.
        await store.dispatch("auth/refreshAccessToken").then(() => {
          // Local Storage에서 JWT를 다시 가져온다.
          jwt = localStorage.getItem(jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN);
        });
      }

      config.headers["Authorization"] = "Bearer " + jwt;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      store.commit("auth/reset");
      router.replace("/auth");
    }

    return Promise.reject(error);
  }
);

/**
 * @brief 인증이 필요한 요청인지 확인
 * @param url 요청 URL
 * @return 인증이 필요한 요청인지 여부 boolean 값
 */
function isAuthRequest(url) {
  // 인증이 필요한 경로
  if (
    /\/api\/admin|\/api\/user|\/api\/corp/.test(url) ||
    /\/api\/auth\/signout/.test(url) ||
    /\/api\/qna\//.test(url) ||
    /\/api\/survey/.test(url) ||
    /\/api\/profile/.test(url) ||
    /\/api\/matching/.test(url) ||
    /\/api\/comments/.test(url) ||
    /\/api\/getCommentsByServiceIdx/.test(url) ||
    /\/api\/inBody/.test(url) ||
    (/\/api\/account/.test(url) &&
      ![
        "/api/account/upload-avatar",
        "/api/account/signup/individual",
        "/api/account/signup/corp",
      ].includes(url))
  ) {
    return true;
  }

  return false;
}

export default instance;
